import { Store } from '@reduxjs/toolkit';

import { storeHomeResponse } from '../../app/homeSlice';
import { store } from '../../app/store';
import {
  ApiRequest,
  ApiResponse,
  getHandler,
  handleApiError,
  Handler,
} from '../../types/Api';
import { API_CONFIG, RequestName } from '../api.types';
import { httpRequest } from '../http/client';
import { ResponseCode } from '../http/httpConsts';

export const handleOk = async (
  store: Store,
  response: ApiResponse,
  params?: { onSuccess: () => void; onFail: () => void }
) => {
  const res = response.data.body;

  store.dispatch(storeHomeResponse(res));
  params?.onSuccess();
};

const handleGenericError = (
  store: Store,
  response: ApiResponse,
  params?: { onSuccess: () => void; onFail?: () => void }
) => {
  const res = response.data.body as ApiResponse;

  handleApiError(RequestName.LOAD_HOME, res);
  params?.onFail?.();
};

const handlers: Handler = {
  [ResponseCode.OK]: handleOk,
};

interface LoadHomeParams {
  onSuccess: () => void;
  onFail?: () => void;
}

export const loadHome = async ({ onSuccess, onFail }: LoadHomeParams) => {
  const req = {
    config: API_CONFIG.LOAD_HOME,
  } as ApiRequest;
  const apiResponse = await httpRequest(req);

  const handler = getHandler(apiResponse.status, handlers, handleGenericError);
  handler(store, apiResponse, { onSuccess, onFail });
};
